export default "__VITE_ASSET__BrXFixVo__"